import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "app-icon-pause-btn",
  "use": "app-icon-pause-btn-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"app-icon-pause-btn\"><g fill=\"#6C92FA\" fill-rule=\"evenodd\"><path d=\"M2.5 2h4v12h-4zM9.5 2h4v12h-4z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol